<template>
  <div class="container pb-4 mb-4">

    <div class="row">
      <div class="col"><h5 class="mb-3">Emails</h5></div>
    </div>

    <div class="row">
      <div class="col">
        <search-box @update-search="updateSearch"></search-box>
      </div>
    </div>

    <div class="card">
      <div class="card-body pb-0">

        <div v-if="loading" class="text-center pb-3"><i class="fas fa-spinner fa-spin"></i></div>

        <div v-else-if="emails.length == 0" class="text-center pb-3">No emails sent</div>

        <span v-else>

          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th class="first-left pl-3" width="20%">Name</th>
                <th class="pl-3" width="30%">Email</th>
                <th class="pl-3" width="30%">Subject</th>
                <th class="first-right pl-3" width="20%">Date</th>
              </tr>
            </thead>
            <tbody>
              <tr class="body2" v-for="(email, index) in emails" :key="index">
                <td class="pl-3">{{ email.name }}</td>
                <td class="pl-3"><a :href="getWebsite(email.email)" target="_blank">{{ email.email }}</a></td>
                <td class="pl-3"><a href="#/" @click="showModal(email)">{{email.subject}}</a></td>
                <td class="pl-3">
                  <div :title="formatDateMoment(email.created_at, timezone)">
                    {{ timeAgo(email.created_at, timezone) }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </span>
        <view-email :email="emailInfo"></view-email>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      emails: [],
      emailInfo: {},
      loading: true,
      timezone: 'Africa/Johannesburg',
      mySearchTerm: this.search_term,
    };
  },

  watch: {
    mySearchTerm: function (val) {
      this.getEmails();
    },
  },

  created() {
    this.getEmails();

    Echo.private("emails")
      .listen("UpdateEmails", (event) => {
        this.getEmails();
      });
  },

  methods: {
    showModal(email) {
      this.emailInfo = email;
      this.$bvModal.show(`bv-modal-view-email`);
    },

    updateSearch(newSearchTerm) {
      this.mySearchTerm = newSearchTerm;
    },

    getEmails() {
      axios
        .post(`/emails/list`, {
          search_term: this.mySearchTerm,
        })
        .then((response) => {
          this.emails = response.data;
          this.loading = false;
        });
    },
  },
};
</script> 